<template>
    <div>
        <div v-if="!status.detail" class="text-center p-4">
            <b-spinner variant="info" role="status" />
        </div>
        <b-alert v-else-if="loadFailed" show variant="danger">
            {{ $t('message.unknownError') }}
            <b-button size="sm" variant="outline-danger" @click="getSportClubBoardTypeData">{{ $t('label.reset') }}</b-button>
        </b-alert>
        <form v-else @submit.prevent="sportClubBoardTypeUUID ? requestUpdate() : requestCreate()">
            <b-form-group :label="$t('label.name')" label-cols="4" label-align="left" label-for="sportClubBoardType-name">
                <b-form-input id="sportClubBoardType-name" v-model.trim="createForm.name" :maxlength="30"
                    :class="{ 'is-invalid': submitted && $v.createForm.name.$error }"
                    :disabled="!status.save" autocomplete="off" />
                <b-form-invalid-feedback v-if="submitted && !$v.createForm.name.required">
                    {{ $t('message.requiredX', [$t('label.name')]) }}
                </b-form-invalid-feedback>
                <b-form-invalid-feedback v-else-if="submitted && !$v.createForm.name.maxLength">
                    Maximum 30 characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <hr class="my-3 mx-n4" />
            <div class="d-flex justify-content-end w-100">
                <b-button type="button" variant="danger" class="mr-2" :disabled="!status.save" @click="$emit('done')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button type="submit" variant="info" :disabled="!status.save">
                    <span v-if="status.save">{{ sportClubBoardTypeUUID ? $t('label.updateX', []) : $t('label.createX', []) }}</span>
                    <b-spinner v-else small />
                </b-button>
            </div>
        </form>
    </div>
</template>
<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { sportClubBoardTypeMethods } from '@/state/api';
import { SPORT_CLUB_BOARD_TYPE_MODULE } from '@/state/api/sportClubBoardType.state';

export default {
    props: {
        sportClubBoardTypeUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true },
    },
    data() {
        return { submitted: false, loadFailed: false, createForm: this.defaultForm() };
    },
    validations() {
        return { createForm: { name: { required, maxLength: maxLength(30) } } };
    },
    computed: {
        ...mapState(SPORT_CLUB_BOARD_TYPE_MODULE, ['status']),
        data() { return this.$store.state.api.sportClubBoardType.details; },
    },
    created() { this.getSportClubBoardTypeData(); },
    methods: {
        ...sportClubBoardTypeMethods,
        defaultForm() { return { uuid: '', name: '' }; },
        async getSportClubBoardTypeData() {
            if (!this.sportClubBoardTypeUUID) return;
            const result = await this.getSportClubBoardType({ uuid: this.sportClubBoardTypeUUID });
            this.loadFailed = !result;
            if (result) this.createForm = { uuid: this.data.uuid, name: this.data.name };
        },
        requestCreate() { return this.save(this.createSportClubBoardType); },
        requestUpdate() { return this.save(this.updateSportClubBoardType); },
        async save(action) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid || !this.status.save) return;
            const result = await action({ data: { ...this.createForm }, filter: this.searchCriteria });
            if (result) {
                this.resetForm();
                this.$emit('done');
            }
        },
        resetForm() {
            this.createForm = this.defaultForm();
            this.submitted = false;
            this.$v.$reset();
        },
    },
};
</script>
